export enum VERIFICATION_STATUS {
  NONE = 'NOT STARTED',
  NEW = 'NOT STARTED',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
